import queryString from 'qs';
import React from 'react';
import { withRouter } from 'react-router';
import SearchField from '../Search/searchfield';
import EntryFormSearchField from './entryform-searchfield';
import './styles.scss';

/**
 * Repo: PWT-PlatformUI
 *
 * Sites: RGS
 *
 * @description
 *  Entry form block to a searchpage.
 *  No autocomplete/suggestions.
 *
 */
const SearchEntryForm = (props) => {
  const qs = queryString.parse(props.location.search, {
    ignoreQueryPrefix: true,
  });
  return (
    <div className="row">
      <div className="columns small-12">
        <div className="entryform-searchform">
          <form
            className="c-search entryform-searchblock__form"
            method="get"
            autoComplete="off"
            action={props.SearchUrl}
          >
            <fieldset>
              {props.Heading && (
                <legend className={'c-search__legend'}>{props.Heading}</legend>
              )}
              <div className="c-search__field">
                <label
                  className="c-search__field__label icon-search"
                  htmlFor="section-search"
                >
                  {props.CurrentPageProps.Content.Translations.search && (
                    <span className="show-for-sr">
                      {props.CurrentPageProps.Content.Translations.search}
                    </span>
                  )}
                </label>
                {props.DefaultFacet && (
                  <input
                    type="hidden"
                    name="theme"
                    value={props.DefaultFacet}
                  />
                )}

                <EntryFormSearchField
                  id="section-search"
                  className="c-search"
                  initialValue={qs.q}
                  placeholder={props.SearchPlaceholder}
                />
                <button className="c-search__field__button" type="submit">
                  {props.Translations.searchbutton}
                </button>
              </div>
            </fieldset>
          </form>
        </div>
      </div>
    </div>
  );
};

/**
 * Repo: PWT-PlatformUI
 *
 * Sites: NKK
 * @description
 *  Entry form block to a searchpage.
 *  With autocomplete, suggestions and quicksearch
 */

const SearchEntryFormWithAutocomplete = (props) => {
  const hasQuickSearch =
    typeof props.QuickSearchUrl !== 'undefined' &&
    props.QuickSearchUrl !== null;
  return (
    <div className="row">
      <div className="columns small-12">
        <div className="entryform-searchform" role="search">
          <form
            className="c-search entryform-searchblock__form"
            action={props.SearchUrl}
            method="get"
            autoComplete="off"
          >
            <div className="c-search__field">
              <label
                className="c-search__field__label icon-search"
                htmlFor="globalsearch"
              >
                <span className="show-for-sr">{props.SearchPlaceholder}</span>
              </label>

              <SearchField
                id="section-search"
                className="search-block c-search"
                searchUrl={props.SearchUrl}
                placeholder={props.SearchPlaceholder}
                hasNoAutocomplete={props.hasNoAutocomplete}
                hasQuickSearch={hasQuickSearch}
                showSearchHitsHeadingSuffix
              />

              <button type="submit" className="c-search__field__button">
                {props.Translations.searchbutton}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default withRouter(SearchEntryForm);

export { SearchEntryFormWithAutocomplete };
